module.exports = __webpack_public_path__ + "img/79.9eb73803.jpg";